export enum InventoryAction {
  STOCK_CREATED = "STOCK_CREATED",
  STOCK_UPDATED = "STOCK_UPDATED",
  STOCK_ARCHIVED = "STOCK_ARCHIVED",
  DRAWDOWN = "DRAWDOWN",
  PARTIAL_DRAWDOWN = "PARTIAL_DRAWDOWN",
  RESTORED = "RESTORED",
  PARTIAL_RESTORED = "PARTIAL_RESTORED",
  SHIPMENT_RECEIVED = "SHIPMENT_RECEIVED",
  SHIPMENT_UPDATED = "SHIPMENT_UPDATED",
  SHIPMENT_ADJUSTED_UP = "SHIPMENT_ADJUSTED_UP",
  SHIPMENT_ADJUSTED_DOWN = "SHIPMENT_ADJUSTED_DOWN",
  SHIPMENT_ARCHIVED = "SHIPMENT_ARCHIVED",
  ITEM_LINKED = "ITEM_LINKED",
  ITEM_UNLINKED = "ITEM_UNLINKED",
  SUPPLIER_TO_STOCK_LINKED = "SUPPLIER_TO_STOCK_LINKED",
  SUPPLIER_TO_STOCK_UPDATED = "SUPPLIER_TO_STOCK_UPDATED",
  SUPPLIER_TO_STOCK_UNLINKED = "SUPPLIER_TO_STOCK_UNLINKED",
  PO_CREATED = "PO_CREATED",
  PO_PLACED = "PO_PLACED",
  PO_CANCELLED = "PO_CANCELLED",
  PO_COMPLETED = "PO_COMPLETED",
  PO_ARCHIVED = "PO_ARCHIVED",
  TRANSFER_OUT = "TRANSFER_OUT",
  TRANSFER_IN = "TRANSFER_IN",
  LOST_IN_TRANSIT = "LOST_IN_TRANSIT",
  BARCODE_ADDED = "BARCODE_ADDED",
  BARCODE_UPDATED = "BARCODE_UPDATED",
  BARCODE_ARCHIVED = "BARCODE_ARCHIVED",
}
